import { initStorageInstance } from './index'
import {
  AGRICULTURA_LOAN_UNACTIVETED_SNS_STORAGE_KEY,
  AGRICULTURA_LOAN_SELECTED_ADDRESS_STORAGE_KEY,
  AGRICULTURA_LOAN_CONFIRM_USE_PACKAE_INFO_STORAGE_KEY,
  AGRICULTURA_LOAN_BIND_DEVICE_INFO_STORAGE_KEY,
  AGRICULTURA_LOAN_CURRENT_PACKAGE_SELECTION_INFO_STORAGE_KEY,
  AGRICULTURA_LOAN_VERIFY_SMSCODE_STORAGE_KEY,
  AGRICULTURA_LOAN_CURRENT_PACKAGE_SUBCODES_STORAGE_KEY,
} from './constant'

// export const MalfunctionRepairScanListStorage
export const UnActivetedSnsStorage = initStorageInstance(
  AGRICULTURA_LOAN_UNACTIVETED_SNS_STORAGE_KEY,
  {
    type: 'sessionStorage',
    verifyMobile: true,
  }
)

export const SelectedAddressInfoStorage = initStorageInstance(
  AGRICULTURA_LOAN_SELECTED_ADDRESS_STORAGE_KEY,
  {
    type: 'sessionStorage',
    once: true,
  }
)

// 已确认选配件信息缓存
export const ConfirmUsePackageInfoStorage = initStorageInstance(
  AGRICULTURA_LOAN_CONFIRM_USE_PACKAE_INFO_STORAGE_KEY,
  {
    type: 'sessionStorage',
    once: true,
  }
)

// 已确认添加绑定的设备信息缓存
export const ConfirmBindDeviceInfoStorage = initStorageInstance(
  AGRICULTURA_LOAN_BIND_DEVICE_INFO_STORAGE_KEY,
  {
    type: 'sessionStorage',
    once: true,
  }
)

// 当前套餐信息缓存
export const CurrentPackageSelectionInfoStorage = initStorageInstance(
  AGRICULTURA_LOAN_CURRENT_PACKAGE_SELECTION_INFO_STORAGE_KEY,
  {
    type: 'sessionStorage',
    once: true,
  }
)

// 发送验证码的倒计时存储
export const VerifySmsCodeStartTime = initStorageInstance(
  AGRICULTURA_LOAN_VERIFY_SMSCODE_STORAGE_KEY,
  {
    type: 'localStorage',
    verifyMobile: true,
  }
)

// 套餐设备可选物料编码缓存
export const PackageSelectionCodeMapStorage = initStorageInstance(
  AGRICULTURA_LOAN_CURRENT_PACKAGE_SUBCODES_STORAGE_KEY,
  { type: 'sessionStorage' }
)
